var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78723 23.75H11.5372V16.25H19.0372V23.75H22.7872V12.5L15.2872 6.875L7.78723 12.5V23.75ZM7.78723 26.25C7.09973 26.25 6.51098 26.005 6.02098 25.515C5.53098 25.025 5.2864 24.4367 5.28723 23.75V12.5C5.28723 12.1042 5.37598 11.7292 5.55348 11.375C5.73098 11.0208 5.97557 10.7292 6.28723 10.5L13.7872 4.875C14.0164 4.70833 14.256 4.58333 14.506 4.5C14.756 4.41667 15.0164 4.375 15.2872 4.375C15.5581 4.375 15.8185 4.41667 16.0685 4.5C16.3185 4.58333 16.5581 4.70833 16.7872 4.875L24.2872 10.5C24.5997 10.7292 24.8447 11.0208 25.0222 11.375C25.1997 11.7292 25.2881 12.1042 25.2872 12.5V23.75C25.2872 24.4375 25.0422 25.0263 24.5522 25.5163C24.0622 26.0063 23.4739 26.2508 22.7872 26.25H16.5372V18.75H14.0372V26.25H7.78723Z",
    fill: "#004B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelGeneral);
export default __webpack_public_path__ + "static/media/panel-general.70866fbd5e7bf2e1cd983337e07d479e.svg";
export { ForwardRef as ReactComponent };